module.exports = __webpack_public_path__ + "static/media/Slide2.89a63f92.JPG";